import { EuiFlexGroup, EuiFlexItem, EuiText } from '@equipmentshare/ds2'
import { InventoryLocation } from 'inventory-web'
import getSubHeaderText from './helpers/getSubHeaderText'
import useStoreIds from 'hooks/useStoreIds'
import { useInventoryLocationsQuery } from '../../../graphql'

import './index.css'

export type InventoryLocationsSubHeaderProps = {
  pageTitle: string,
}

export default function InventoryLocationsSubHeader( { pageTitle }: InventoryLocationsSubHeaderProps ) {
	const { inventoryLocationIds } = useStoreIds()
	const { data } = useInventoryLocationsQuery( { variables: { inventoryLocationIds } } )
	const inventoryLocations: InventoryLocation[] = data?.inventoryLocations.edges.map( ( edge ) => edge.node ) ?? []
	const headerText = getSubHeaderText( inventoryLocations, inventoryLocationIds, pageTitle )

	return (
		<EuiFlexGroup>
			<EuiFlexItem grow={false}>
				<EuiText size="s">
					<h4 id="store-filter-header">{headerText}</h4>
				</EuiText>
			</EuiFlexItem>
		</EuiFlexGroup>
	)
}
